/**
 * One number across the consult surfaces: `apps/consult` and `apps/ffs-signup` between them shipped
 * three different literals, so a member's dialable number depended on which failure they hit.
 *
 * FLAGGED FOR THE BUSINESS, NOT DECIDED HERE: `855-659-3663` may be the more correct number — it is
 * the general NourishedRx member line, and care-betty's SMS templates use it for the message that
 * delivers a consult-scheduling link. Change both values here when an owner answers.
 */
export const SUPPORT_PHONE_DISPLAY = '833-349-0399';

/** E.164: a bare `tel:833-349-0399` is dialable from a US handset but not from roaming or VoIP. */
export const SUPPORT_PHONE_HREF = 'tel:+18333490399';
